import styled from 'styled-components'

const StyledPageOverlay = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 50px);
  justify-content: center;
  align-items: center;
`

export default StyledPageOverlay
